export const SET_STATE = 'templates/hotel/SET_STATE';
export const SET_FLOATING_PACKAGE_PRICE_CLICKED = 'template/hotel/SET_FLOATING_PACKAGE_PRICE_CLICKED';
export const SET_FLOATING_PACKAGE_PRICE_VISIBILITY = 'template/hotel/SET_FLOATING_PACKAGE_PRICE_VISIBILITY';
export const SET_FLOATING_PACKAGE_PRICE_STYLE = 'template/hotel/SET_FLOATING_PACKAGE_PRICE_STYLE';
export const SET_TRANSITION_TO_CHECKOUT = 'template/hotel/SET_TRANSITION_TO_CHECKOUT';
